export function setAndClearTimeout(callback: () => void, delay: number) {
  const id = window.setTimeout(callback, delay)
  return () => window.clearTimeout(id)
}
